module.exports = __webpack_public_path__ + "img/service-audit-2.386e2ef8.png";